export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'regulacao-parametrizacao' */
            '@/views/regulacao/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/index',
        children: [
            {
                name: 'regulacao-parametrizacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-parametrizacao' */
                    '@/views/regulacao/parametrizacao/Form.vue'
                ),
            },
        ],
    },
]